//libs
import { useCallback, useState } from 'react';
import { SOURCE } from 'shared/components/EstimatedDeliveryDetails/constants';

//services
import { getEstimatedDeliveryDate } from 'shared/api/product-details';

const DEFAULT_ERROR = 'Something went wrong';

const useEDD = () => {
  const [isFetching, setIsFetching] = useState(false);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  const reset = () => {
    setIsFetching(false);
    setData(null);
    setError(null);
  };

  const fetchData = useCallback(
    ({
      SKUs = [],
      source = SOURCE.PDP,
      pinCode,
      successCallback = () => {},
      failureCallback = () => {},
      type = '',
    }) => {
      setIsFetching(true);
      setError(null);
      setData(null);

      getEstimatedDeliveryDate({ pincode: pinCode, source, SKUs, type })
        .then((response) => {
          setIsFetching(false);
          setData(response);
          successCallback(response);
        })
        .catch((err) => {
          setIsFetching(false);
          setError(err.message || DEFAULT_ERROR);
          failureCallback(err.message || DEFAULT_ERROR);
        });
    },
    []
  );

  return {
    isFetching,
    data,
    error,
    fetchData,
    reset,
  };
};

export default useEDD;
